import React, { Component } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import "../Input_datepicker.css";

import { get } from ".././common/fetch";
import Gettext, { withGettext } from ".././common/Gettext";
import ErrorText from "../ErrorText";
import Input from "../Input";
import SettingsHeader from "../SettingsHeader";

import PassportFile from "../PassportFile";
import PassportScanInput from "../PassportScanInput";
import Button from "../Button";
import { DateIcon, TimeIcon, TimefaceIcon } from "../Icons";

import {
  BonusHeader,
  BonusSelect,
  ButtonContainer,
  ButtonWrapper,
  Close,
  Header,
  HelpTextView,
  InputItem1,
  InputItemView,
  KdongAmount,
  KdongContainer,
  KdongInfo,
  KdongKdong,
  Label,
  MainView,
  Overlay,
  Popup,
  PopupInner,
  PopupTableCell,
  RowContainerView,
  ScanItemContainer,
  ScanItemInfo,
  SectionView
} from "./StyledComponents";
import OfflineConfirmed from "./OfflineConfirmed";
import OfflineFilePreview from "./OfflineFilePreview";
import TimeSelector from "./TimeSelector";
import Select from "./Select";

const DONG = "₫";
const KDONG = "k₫";

const Row = props => (
  <RowContainerView inlineRow={props.inlineRow} desktop={props.desktop}>
    {(props.desktop || props.showHeader) && (
      <SettingsHeader
        title={props.title}
        subtitle={props.subtitle}
        showColon={props.desktop}
        desktop={props.desktop}
      />
    )}
    {props.nowrap ? (
      props.children
    ) : (
      <MainView desktop={props.desktop}>{props.children}</MainView>
    )}
  </RowContainerView>
);

const HelpText = props => <HelpTextView>{props.children}</HelpTextView>;

const InputItem = ({ children, desktop }) => (
  <InputItemView desktop={desktop}>{children}</InputItemView>
);

const Section = ({ children, desktop }) => (
  <SectionView desktop={desktop}>{children}</SectionView>
);

const Main = ({ children, desktop }) => (
  <MainView desktop={desktop}>{children}</MainView>
);

const RowContainer = ({
  children,
  noInputItem,
  desktop,
  title,
  desc,
  nowrap,
  inlineRow,
  showAlternateHelp,
  alternateHelp,
  error,
  style
}) => (
  <Row
    title={title}
    desktop={desktop}
    nowrap={nowrap}
    inlineRow={inlineRow}
    style={style}
  >
    <Main desktop={desktop}>
      {noInputItem ? (
        children
      ) : (
        <div>
          {children && <InputItem desktop={desktop}>{children}</InputItem>}
          {!!error && !desktop && (
            <InputItem1 desktop={desktop}>
              <ErrorText>{error}</ErrorText>
            </InputItem1>
          )}

          {!!(desc || (showAlternateHelp && alternateHelp)) && (
            <InputItem desktop={desktop}>
              {showAlternateHelp ? alternateHelp : <HelpText>{desc}</HelpText>}
            </InputItem>
          )}
        </div>
      )}
    </Main>
    {!!error && desktop && (
      <InputItem1 desktop={desktop}>
        <ErrorText>{error}</ErrorText>
      </InputItem1>
    )}
  </Row>
);

class OfflinePopup extends Component {
  constructor(props) {
    super(props);

    this.onAmountChange = this.onAmountChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onDateBlur = this.onDateBlur.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.onTimeBlur = this.onTimeBlur.bind(this);
    this.focusBonus = this.focusBonus.bind(this);
    this.defocusBonus = this.defocusBonus.bind(this);
    this.toggleFile = this.toggleFile.bind(this);
    this.sendInfo = this.sendInfo.bind(this);

    this.onFileUpload = this.onFileUpload.bind(this);
    this.onFileDelete = this.onFileDelete.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // Default locale for moment is EN so no need to set it again
    if (props.lang && props.lang !== "en") {
      moment.locale(props.lang);
    }

    let bank = "";
    let amount = "";

    if (props.offlinePayment) {
      bank = props.offlinePayment.bank;
      if (props.currency === "VND") {
        amount = props.offlinePayment.amount * 1000; // Make dongs out of kilodongs
      } else {
        amount = props.offlinePayment.amount;
      }
    }

    this.state = {
      bank: bank,
      showBonus: false,
      showFilePreview: false,
      sentData: false,

      amount: amount,
      amountError: "",
      date: "",
      dateError: "",
      time: "",
      timeError: "",
      file: props.file,
      fileImg: null,
      fileError: "",

      done: false,
      sending: false,
      error: ""
    };
  }

  componentDidMount() {
    document.body.style.setProperty("overflow", "hidden", "important");

    const { isiOSApp, appVersion } = this.props;

    if (isiOSApp && appVersion >= 2000000) {
      let el = ReactDOM.findDOMNode(this);
      if (el) {
        el.style.setProperty("top", 0);
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
  }

  onAmountChange(data) {
    const value = parseInt(data || 0, 10);

    if (isNaN(value)) {
      return false;
    }

    this.setState({
      amount: value,
      amountError: ""
    });
  }

  onDateChange(data) {
    let date = data;

    if (this.isDateFieldWorks()) {
      // date = typeof data === "string" ? moment(data) : data;
    } else {
      // If input[type=date] doesn't work properly then simply leave date
      // as raw input value
    }

    this.setState({
      date,
      dateError: ""
    });
  }

  onDateBlur() {
    const d = this.state.date;
    let date = d;
    let wrongInput = false;

    if (typeof d === "string") {
      let dateFormat;
      let split;

      if (d.indexOf(".") > 0) {
        dateFormat = "DD.MM.YYYY";
        split = ".";
      } else if (d.indexOf("-") > 0) {
        dateFormat = "YYYY-MM-DD";
        split = "-";
      } else {
        wrongInput = true;
      }

      if (!wrongInput) {
        const [_d, _m, _y] = d.split(split);
        wrongInput = isNaN(+_d) || isNaN(+_m) || isNaN(+_y);
        date = moment(d, dateFormat);
      }
    }

    let day;
    let month;
    let year;

    if (typeof date === "object") {
      day = date.date();
      month = date.month();
      year = date.year();
    }

    const isValidDate = !wrongInput && this.validateDate(date);

    let dateError = "";

    if (
      wrongInput ||
      !isValidDate ||
      day > 31 ||
      month > 12 ||
      year > moment().year() ||
      year < moment().year() - 1
    ) {
      dateError = this.props.gettext`Invalid date`;
    }

    this.setState({
      dateError
    });
  }

  onTimeChange(data) {
    this.setState({
      time: data,
      timeError: ""
    });
  }

  onTimeBlur() {
    const [hours, minutes] = (this.state.time || ":").split(":");
    let timeError = "";

    const h = +hours;
    const m = +minutes;

    if (
      hours === "" ||
      minutes === "" ||
      isNaN(h) ||
      isNaN(m) ||
      h < 0 ||
      m < 0 ||
      h > 23 ||
      m > 59
    ) {
      timeError = this.props.gettext`Invalid time`;
    }

    this.setState({
      timeError
    });
  }
  /**
   * Validate date.
   * @param  {Object} date Moment.js date object.
   * @return {Boolean}
   */
  validateDate(date) {
    // Within 3 days offline payment expires
    // UPD. It's not true at all.
    /*
    const dateValidForDays = 3;

    const dateAfter = moment().subtract(dateValidForDays, 'days');
    const dateBefore = moment();
    const isValidDate = date.isBetween(dateAfter, dateBefore);
    */

    const dateBefore = moment();
    const isValidDate = date.isBefore(dateBefore);

    return isValidDate;
  }

  isDateFieldWorks() {
    return !!(
      this.dateInput &&
      this.dateInput.input &&
      this.dateInput.input.type === "date"
    );
  }

  onFileUpload(files) {
    const file = files && files[0];

    if (file && FileReader && typeof FileReader === "function") {
      const reader = new FileReader();

      reader.addEventListener("load", event => {
        this.setState({
          file,
          fileImg: reader.result,
          fileError: ""
        });
      });

      reader.addEventListener("error", event => {
        let fileError = "";
        const err = reader.error.name;

        if (err === "SecurityError") {
          fileError = this.props
            .gettext`Please, grant access to Storage for the browser`;
          this.setState({
            file: null,
            fileError
          });
        } else {
          this.setState({
            file,
            fileError
          });
        }
      });

      reader.readAsDataURL(file);
    } else {
      this.setState({
        file,
        fileError: ""
      });
    }
  }

  onFileDelete() {
    this.setState({
      file: null,
      error: "",
      showFilePreview: false
    });
  }

  /**
   * @deprecated
   */
  onSubmit() {
    let formData = new FormData();
    formData.append("old_pid", this.props.paymentId);
    formData.append("wireless_scan", this.state.file);

    this.setState({
      sending: true,
      error: ""
    });

    get(`/upload-invoice`, {
      mode: "cors",
      credentials: "include",
      method: "POST",
      body: formData
    })
      .catch(error => error)
      .then(data => {
        this.setState({
          sending: false,
          done: data.status === "OK",
          error: data.status !== "OK" && data.message
        });
      });
  }

  focusBonus() {
    this.setState({ showBonus: true });
  }

  defocusBonus() {
    this.setState({ showBonus: false });
  }

  shouldConvertDongToKdong() {
    return this.props.currency === "VND";
  }

  toggleFile(e) {
    e && e.preventDefault();

    this.setState({ showFilePreview: !this.state.showFilePreview });
  }

  getDateFormatted(date) {
    // If date is moment object, call it's format method
    if (date && typeof date.format === "function") {
      return date.locale("en").format("DD/MM/YYYY");
    } else if (typeof date.indexOf === "function") {
      return moment(date)
        .locale("en")
        .format("DD/MM/YYYY");
    } else {
      let d = moment(date);
      return d.locale("en").format("DD/MM/YYYY");
    }
  }

  sendInfo(e) {
    e && e.preventDefault();

    let errors = {};

    if (!this.state.amount) {
      errors.amountError = this.props.gettext`Required field`;
    }

    if (!this.state.date) {
      errors.dateError = this.props.gettext`Required field`;
    }

    if (this.state.dateError) {
      errors.dateError = this.state.dateError;
    }

    if (!this.state.time) {
      errors.timeError = this.props.gettext`Required field`;
    }
    if (this.state.timeError) {
      errors.timeError = this.state.timeError;
    }

    if (!this.state.file) {
      errors.fileError = this.props.gettext`Required field`;
    }

    if (Object.keys(errors).length) {
      this.setState({
        ...errors,
        showFilePreview: false
      });

      return false;
    }

    let date = this.getDateFormatted(this.state.date);

    let formData = new FormData();
    formData.append("orderId", this.props.paymentId);

    let bank = this.state.bank;
    let recipient;
    if (bank) {
      const selectedBank = this.props.banks.find(bank => bank["bank-code"] === this.state.bank);
      if (selectedBank) {
        recipient = selectedBank["bank-acc-name"];
      }
    } else {
      bank = this.props.banks[0]["bank-code"];
      recipient = this.props.banks[0]["bank-acc-name"];
    }

    formData.append("bankCode", bank);
    formData.append("recipientName", recipient);

    if (this.shouldConvertDongToKdong()) {
      // Amount in dongs, should send kdongs
      formData.append("amount", this.state.amount / 1000);
    } else {
      formData.append("amount", this.state.amount);
    }

    formData.append("date", date);
    formData.append("time", this.state.time);
    formData.append("wireless_scan", this.state.file);

    this.setState({
      sending: true,
      error: ""
    });

    get(`/ajax/offline-payment-modal`, {
      mode: "cors",
      credentials: "include",
      method: "POST",
      body: formData
    })
      .catch(error => error)
      .then(data => {
        const OK = data.status === "OK";

        this.setState({
          sentData: OK,
          sending: false,
          done: OK, // Still need this?
          error: !OK && data.message
        });

        const clb = this.props.onConfirm;

        if (typeof clb === "function" && OK) {
          clb();
        }

        if (!OK && typeof this.props.onFail === "function") {
          this.props.onFail();
        }
      });
  }

  render() {
    const {
      banks,
      recipient: recipientProp,
      isATM,
      currencySymbol,
      desktop,
      isiOSApp,
      isAndroidApp,
      appVersion
    } = this.props;

    const isIOSApp = isiOSApp && appVersion >= 2000000;
    const file = this.state.file;

    let selectedBank = banks[0];
    if (this.state.bank) {
      selectedBank = banks.find(bank => bank["bank-code"] === this.state.bank);
    }

    let account;
    let recipient = recipientProp;
    if (selectedBank) {
      account = selectedBank["bank-acc-number"];
      recipient = selectedBank["bank-acc-name"];
    }

    const alternateAmountHelpBox = (
      <div>
        {desktop && (
          <BonusHeader>
            <Gettext>Your bonus</Gettext>
          </BonusHeader>
        )}

        <BonusSelect desktop={desktop}>
          <Select
            id="bonus"
            value="50% (12500 Baht)"
            label={this.props.gettext`Your bonus`}
            desktop={desktop}
          >
            <option value="1">50% (12500 Baht)</option>
            <option value="2">No bonus</option>
          </Select>
        </BonusSelect>
      </div>
    );

    const FormFields = (
      <Section desktop={desktop}>
        <RowContainer
          title={this.props.gettext`Bank`}
          desc={this.props
            .gettext`The bank name where you have transferred your money`}
          desktop={desktop}
          nowrap={true}
        >
          <Select
            id="banks"
            value={this.state.bank}
            label={this.props.gettext`Bank`}
            desktop={desktop}
            onChange={data => this.setState({ bank: data })}
          >
            {banks.map((bank, index) => (
              <option key={index} value={bank["bank-code"]}>
                {bank["bank-name"]}
              </option>
            ))}
          </Select>
        </RowContainer>

        <RowContainer
          title={
            isATM
              ? this.props.gettext`ATM card number`
              : this.props.gettext`Account №`
          }
          desc={
            isATM
              ? this.props
                  .gettext`Check the ATM card number. If it's not correct, choose another bank.`
              : this.props
                  .gettext`Check the bank account number. If it's not correct, choose another bank`
          }
          desktop={desktop}
          nowrap={true}
        >
          <Input
            type="text"
            id="bank-acc"
            value={account}
            label={
              isATM
                ? this.props.gettext`ATM card number`
                : this.props.gettext`Account №`
            }
            desktop={desktop}
            invalid={false}
            disabled
            offlinePopup
          />
        </RowContainer>

        {recipient && (
          <RowContainer
            noInputItem={true}
            title={this.props.gettext`Recipient name`}
            desktop={desktop}
            nowrap={true}
          >
            <Input
              type="text"
              id="bank-name"
              value={recipient}
              // value={this.state.first_name}
              // onChange={this.onValueChange('first_name')}
              label={this.props.gettext`Recipient name`}
              desktop={desktop}
              // invalid={!!this.state.first_nameValueError}
              invalid={false}
              disabled
              offlinePopup
            />
          </RowContainer>
        )}

        {this.shouldConvertDongToKdong() ? (
          <RowContainer>
            <RowContainer
              title={this.props.gettext`Amount`}
              desc={this.props
                .gettext`Enter the amount you have transferred (excluding the commission).`}
              desktop={desktop}
              nowrap={true}
              showAlternateHelp={this.state.showBonus}
              alternateHelp={alternateAmountHelpBox}
              error={this.state.amountError}
            >
              <Input
                type="number"
                id="sum-of-order"
                value={this.state.amount}
                label={this.props.gettext`Amount`}
                desktop={desktop}
                invalid={!!this.state.amountError}
                currency={DONG}
                onChange={this.onAmountChange}
                inputMode="numeric"
                pattern="[0-9]*"
                offlinePopup
              />
            </RowContainer>

            {desktop ? (
              <RowContainer
                title={this.props.gettext`Will be credited`}
                desc={`1000 ${DONG} = 1 ${KDONG}`}
                desktop={desktop}
                nowrap={true}
              >
                <KdongAmount>{(this.state.amount || 0) / 1000}</KdongAmount>{" "}
                <KdongKdong>{KDONG}</KdongKdong>
              </RowContainer>
            ) : (
              <Section desktop={desktop}>
                <Row
                  title={this.props.gettext`Will be credited`}
                  desktop={desktop}
                  nowrap={true}
                >
                  <Main desktop={desktop}>
                    <InputItem desktop={desktop}>
                      <Label>
                        <Gettext>Will be credited</Gettext>:
                      </Label>
                    </InputItem>
                    <div>
                      <InputItem desktop={desktop}>
                        <KdongContainer
                          desktop={desktop}
                          style={{ marginBottom: 0 }}
                        >
                          <div>
                            <KdongAmount
                              desktop={desktop}
                              style={{ fontSize: 22 }}
                            >
                              {(this.state.amount || 0) / 1000}
                            </KdongAmount>{" "}
                            <KdongKdong style={{ fontSize: 22 }}>
                              {KDONG}
                            </KdongKdong>
                          </div>
                          <KdongInfo
                            desktop={desktop}
                          >{`1000 ${DONG} = 1 ${KDONG}`}</KdongInfo>
                        </KdongContainer>
                      </InputItem>
                    </div>
                  </Main>
                </Row>
              </Section>
            )}
          </RowContainer>
        ) : (
          <RowContainer
            title={this.props.gettext`Amount`}
            desc={this.props
              .gettext`Enter the amount you have transferred (excluding the commission)`}
            desktop={desktop}
            nowrap={true}
            showAlternateHelp={this.state.showBonus}
            alternateHelp={alternateAmountHelpBox}
            error={this.state.amountError}
          >
            <Input
              type="number"
              id="sum-of-order"
              value={this.state.amount}
              label={this.props.gettext`Amount`}
              desktop={desktop}
              invalid={!!this.state.amountError}
              currency={currencySymbol}
              onChange={this.onAmountChange}
              inputMode="numeric"
              pattern="[0-9]*"
              offlinePopup
            />
          </RowContainer>
        )}

        <RowContainer
          title={this.props.gettext`Date of payment`}
          desc={
            desktop &&
            this.props.gettext`Should be same as the date on your payslip`
          }
          desktop={desktop}
          nowrap={true}
          inlineRow={true}
          error={desktop && this.state.dateError}
        >
          <Input
            type="date"
            ref={input => (this.dateInput = input)}
            maxDate={moment()}
            id="date-of-order"
            placeholder="31.12.2017"
            value={this.state.date}
            onChange={this.onDateChange}
            label={this.props.gettext`Date of payment`}
            desktop={desktop}
            invalid={!!this.state.dateError}
            Icon={DateIcon}
            offlinePopup={true}
            onBlur={this.onDateBlur}
            autoComplete="off"
          />
        </RowContainer>

        <RowContainer
          title={this.props.gettext`Time of payment`}
          desc={
            desktop &&
            this.props.gettext`Should be same as the time on your payslip`
          }
          desktop={desktop}
          nowrap={true}
          inlineRow={true}
          error={desktop && this.state.timeError}
        >
          {desktop ? (
            <TimeSelector
              value={this.state.time}
              onChange={this.onTimeChange}
              invalid={!!this.state.timeError}
              onBlur={this.onTimeBlur}
              autoComplete="off"
            />
          ) : (
            <Input
              type="time"
              id="time-of-order"
              placeholder="23:59"
              defaultValue={this.state.time}
              onChange={this.onTimeChange}
              label={this.props.gettext`Time of payment`}
              desktop={desktop}
              invalid={!!this.state.timeError}
              Icon={desktop ? TimeIcon : TimefaceIcon}
              offlinePopup={true}
              onBlur={this.onTimeBlur}
              autoComplete="off"
            />
          )}
        </RowContainer>

        {!desktop && (
          <div>
            <RowContainer
              desktop={false}
              nowrap={true}
              inlineRow={true}
              error={this.state.dateError}
              style={{ verticalAlign: "top !important" }}
            />
            <RowContainer
              desktop={false}
              nowrap={true}
              inlineRow={true}
              error={this.state.timeError}
              style={{ verticalAlign: "top !important" }}
            />
          </div>
        )}

        {!desktop && (
          <Row>
            <Main desktop={desktop}>
              <InputItem desktop={desktop}>
                <HelpText>
                  <Gettext>
                    Date and time should match with the date and time on a
                    receipt.
                  </Gettext>
                </HelpText>
              </InputItem>
            </Main>
          </Row>
        )}
      </Section>
    );

    const FileFields = (
      <Section desktop={desktop} style={!file && { marginBottom: 0 }}>
        <Row
          title={this.props.gettext`The photo of a payslip`}
          desktop={desktop}
          nowrap={true}
        >
          <Main desktop={desktop}>
            {!desktop && (
              <InputItem desktop={desktop}>
                <Label>
                  <Gettext>The photo of a payslip</Gettext>:
                </Label>
              </InputItem>
            )}

            {!!file ? (
              <PassportFile
                name={file.name}
                offpay
                desktop
                viewable={this.state.fileImg !== null}
                activeView={this.state.showFilePreview}
                onClick={this.toggleFile}
                onDelete={this.onFileDelete}
              />
            ) : (
              <div>
                <InputItem desktop={desktop}>
                  <ScanItemContainer desktop={desktop}>
                    <PassportScanInput
                      id="trans-order-copy"
                      desktop
                      offlinePopup
                      onChange={this.onFileUpload}
                    />
                  </ScanItemContainer>
                </InputItem>

                {/* ошибка для мобильной версии */}
                {!!this.state.fileError && !desktop && (
                  <InputItem1
                    style={{
                      textAlign: "center",
                      width: "100%",
                      marginBottom: 14
                    }}
                  >
                    <ErrorText>{this.state.fileError}</ErrorText>
                  </InputItem1>
                )}

                <InputItem desktop={desktop}>
                  <ScanItemInfo desktop={desktop}>
                    <HelpText>
                      <Gettext>
                        Attach the photo/scan of your payment slip
                      </Gettext>
                    </HelpText>
                  </ScanItemInfo>
                </InputItem>
              </div>
            )}
          </Main>

          {/* ошибка для десктопной версии */}
          {!!this.state.fileError && desktop && (
            <InputItem1 desktop={desktop}>
              <ErrorText>{this.state.fileError}</ErrorText>
            </InputItem1>
          )}
        </Row>
      </Section>
    );

    return (
      <Overlay
        desktop={desktop}
        isIOSApp={isIOSApp}
        isAndroidApp={isAndroidApp}
      >
        <Popup desktop={desktop}>
          <PopupTableCell desktop={desktop}>
            <PopupInner desktop={desktop}>
              {desktop && <Close onClick={this.props.onClose} />}
              <Header desktop={desktop}>
                <Gettext>Payment's details</Gettext>
              </Header>

              {this.state.sentData ? (
                <OfflineConfirmed
                  isIOS2={isIOSApp}
                  desktop={desktop}
                  title={this.props
                    .gettext`Your payment request is successfully sent`}
                  message={this.props
                    .gettext`We wish you a successful trading!`}
                  tradeTitle={this.props.gettext`Trading`}
                />
              ) : (
                <div>
                  {!desktop || (desktop && !this.state.showFilePreview)
                    ? FormFields
                    : null}

                  {this.state.showFilePreview && (
                    <OfflineFilePreview
                      file={this.state.fileImg}
                      Row={Row}
                      desktop={desktop}
                      onClose={this.toggleFile}
                    />
                  )}

                  {FileFields}

                  {this.state.error && (
                    <InputItem1
                      style={{
                        marginBottom: 20,
                        width: "100%",
                        textAlign: "center"
                      }}
                    >
                      <ErrorText>{this.state.error}</ErrorText>
                    </InputItem1>
                  )}

                  <ButtonWrapper desktop={desktop}>
                    {!desktop && (
                      <ButtonContainer desktop={desktop}>
                        <Button
                          color="violet"
                          title={this.props.gettext`Cancel`}
                          onClick={this.props.onClose}
                        />
                      </ButtonContainer>
                    )}

                    <ButtonContainer desktop={desktop}>
                      <Button
                        color="green"
                        title={this.props.gettext`Send`}
                        disabled={this.state.sending}
                        big={desktop}
                        wide={desktop}
                        onClick={this.sendInfo}
                        showSpinner={this.state.sending}
                      />
                    </ButtonContainer>
                  </ButtonWrapper>
                </div>
              )}
            </PopupInner>
          </PopupTableCell>
        </Popup>
      </Overlay>
    );
  }
}

export default withGettext(OfflinePopup);



// WEBPACK FOOTER //
// ./src/components/OfflinePopup/OfflinePopup.js